/* globals window document */
import React, { useEffect } from 'react';
import Box from '@material-ui/core/Box';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import { Button } from 'react-admin';

const prodOriginsThatUseStagingSquare = [
  'https://app-service-shop-usa.zippitycars.com',
  'https://service-shop-usa.zippityadmin.com',
  'https://admin-demo-mobile-mechanic.zippity.cc',
  'https://demo-mobile-mechanic.zippityadmin.com',
  'https://admin-demo-mobile-tire.zippity.cc',
  'https://demo-mobile-tire.zippityadmin.com',
  'https://admin-demo-mobile-detailing.zippity.cc',
  'https://demo-mobile-detailing.zippityadmin.com',
  'https://demo-pet-grooming.zippityadmin.com',
  'https://demo-barber-shop.zippityadmin.com',
  'https://demo-bike-repair.zippityadmin.com',
  'https://demo-computer-services.zippityadmin.com',
  'https://demo-salon.zippityadmin.com',
  'https://demo-cell-phone-repair.zippityadmin.com',
  'https://demo-massage.zippityadmin.com',
  'https://demo-carpet-cleaning.zippityadmin.com',
  'https://demo-mobile-services.zippityadmin.com',
  'https://demo-mobile-tire-no-atd.zippityadmin.com',
];

// default Square config to staging
const square = {
  appId: 'sandbox-sq0idb-xZGgYpCYozNAeo9ofWOcKg',
  locationId: 'LGGZFQ2AMT14H',
};
if (
  process.env.REACT_APP_DATA_PROVIDER === 'prod' &&
  !prodOriginsThatUseStagingSquare.includes(document.location.origin)
) {
  square.appId = 'sq0idp-2FLjz7ZlFd_q7h3uxRnXOw';
  square.locationId = 'LMA2A9V2QSE94';
}

const SquareCCInput = ({
  card,
  setCard,
  setShow,
  setHasError,
  responsive = false,
  cancellable = false,
}) => {
  const theme = useTheme();
  const isXSmall = useMediaQuery(theme.breakpoints.down('xs'));

  const initializeCard = (payments) => {
    payments.card().then((c) => {
      c.attach('#card-container').then(() => {
        setCard(c);
      });
    });
  };

  // Listen for any errors from the card form, and use them to disable the submit button.
  useEffect(() => {
    if (card) {
      card.addEventListener('errorClassAdded', () => {
        setHasError(true);
      });
      card.addEventListener('errorClassRemoved', () => {
        setHasError(false);
      });
    }
  }, [card, setHasError]);

  useEffect(() => {
    // When Square input is rendered, reset any errors.
    setHasError(false);

    if (!window.Square) {
      throw new Error('Square.js failed to load properly');
    }
    const payments = window.Square.payments(square.appId, square.locationId);

    // Initialize the card form.
    try {
      initializeCard(payments);
    } catch (e) {
      console.error('Initializing Card failed', e);
    }
  }, []);

  // Clear credit card details.
  const cancel = () => {
    card.destroy();
    setCard(null);
    setShow(false);
    setHasError(false);
  };

  return (
    <Box display="flex" flexDirection="column">
      {cancellable && (
        <Button
          onClick={cancel}
          label="Cancel"
          style={{ alignSelf: 'flex-end' }}
        />
      )}
      <form id="payment-form">
        <div
          style={{
            width: isXSmall || !responsive ? '400px' : '500px',
          }}
          id="card-container"
        />
      </form>
    </Box>
  );
};

export default SquareCCInput;
